/**
* @name: index
* @author: weiyong
* @date: 2022-10-26 22:14
* @description：index
* @update: 2022-10-26 22:14
*/
<template>
  <div class="xmButton"
       :style="[elCtlStyle,props.borderRadius==='userDefDb'?'--borderUserInput:'+props.borderUserInput+'px':'']"
       v-if="showBtn&&props.btnAcl!=='hidden'&&vuex['showCtl']!==false&&isRootAcl&&roleAclDisplayFlag&&(hasCtlAlcFlag ? roleAppAclFlag : true)">
    <a-tooltip placement="top"
               v-if="props.showToolTip">
      <template #title>
        <span>{{ props.toolTipContent }}</span>
      </template>
      <btn-base
        class="w100b"
        :style="elBaseStyle"
        :props="props"
        :btnLabel="roleAclLabel||btnLabel"
        @clickBtn="clickBtn"
        :count="vuex['count']"
        :size="size"
        :userBtnType="userBtnType"
        :disabled="disabled||disabledBtnAcl||roleAclDisabledFlag||vuex['disabled']"
        :loadingFlag="clickLoading||loadingFlag"
        :aclKey="aclKey"
        :events="events"
        :styles="styles"
        :model="model"
      >
        <slot></slot>
      </btn-base>
    </a-tooltip>

    <btn-base
      class="w100b"
      :userBtnType="userBtnType"
      :style="elBaseStyle"
      v-else
      :count="vuex['count']"
      :btnLabel="roleAclLabel||btnLabel"
      :loadingFlag="clickLoading||loadingFlag"
      :disabled="disabled||disabledBtnAcl||roleAclDisabledFlag||vuex['disabled']"
      :props="props"
      :aclKey="aclKey"
      :size="size"
      @clickBtn="clickBtn"
      :events="events"
      :styles="styles"
      :model="model"
    ><slot></slot></btn-base>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xmButtonCtl",
});
</script>

<script lang="ts" setup>
import BtnBase from "@/main-page/components/btnBase.vue";
import {Tooltip as ATooltip, Button as AButton} from "ant-design-vue";
import {useCtlStyle} from "@/main-page/hooks/useCtlStyle";
import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {storeToRefs} from "pinia";
import {useRoleAclHooks} from "@/main-page-base/ctls/containers/xmFormGroupPanel/hook/useRoleAclHooks";
import {usePageRoleAcl} from "@/main-page/ctls/hooks/usePageRoleAcl";
import {inject} from "vue";
import {runWithBtnActionLoading} from "@/main-page-base/ctls/baseCtls/xmButton/hooks/useBtnActionLoading";

const clickLoading=ref(false);
interface propTypes {
  size:string;
  btnLoading:boolean;
  code:boolean;
  useViewModel:any;
  disabled:boolean;
  showBtn:boolean;
  exportCode:boolean;
  userBtnType:string;
  userEvents:any;
  codeCtl:boolean;
  eventParams:any,
  pItem:string,
  props: any,
  loadingFlag:boolean,
  events: any,
  btnLabel:string,
  styles: any,
  aclKey:string,
  model: any,
  disabledBtnAcl:boolean
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  exportCode:false,
  userEvents:[],
  codeCtl:false,
  disabled:false,
  userBtnType:'',
  btnLoading:false,
  size:'',
  code:false,
  useViewModel:null,
  eventParams:{},
  disabledBtnAcl:false,
  showBtn:true,
  pItem:'',
  loadingFlag:false,
  styles: {},
  events: [],
  props: {},
  aclKey:'',
  btnLabel:'',
  model: {},
})
const {eventParams,btnLoading} = toRefs(propsPage);
const {props,events,styles, model} = toRefs(propsPage);

//当前用户的角色配置权限信息 供按钮控制显示隐藏与禁用（未命中配置默认显示且可编辑；newFieldName 与当前名称不一致时替换按钮文案）
const {roleAclDisplayFlag,roleAclDisabledFlag,roleAclLabel}=usePageRoleAcl({props});
const {vuex,isRootAcl} = useVuexState({sectionConfig:props,vuexProps:['showCtl','disabled','showLoading']});
const {elCtlStyle,elBaseStyle} = useCtlStyle({styles,props,propsStyl:['width','height']});

const pageModelsStore = usePageModelsStore();
const {state} = storeToRefs(pageModelsStore);

const roleAppConfigs = inject("roleAppConfigs");
const {roleAppAclFlag, hasCtlAlcFlag} = useRoleAclHooks({roleAppConfigs,props});

const {clickEvent, viewModel} = useComEvent({events,useViewModel:propsPage.useViewModel});
const emits=defineEmits(['clickBtn']);
const clickBtn = async () => {
  if ((window as any).curActiveTab === 'events') {
    return;
  }
  // 未开启点击loading时，保留 btnLoading 的短延时关闭
  if(!unref(props).clickLoading && unref(btnLoading)){
    clickLoading.value=true;
    setTimeout(()=>{
      clickLoading.value=false;
    },unref(props).closeTimer||300)
  }

  emits('clickBtn',{btnObj:unref(props)});
  if(propsPage.exportCode){
    return;
  }
  await runWithBtnActionLoading({
    enabled: !!unref(props).clickLoading,
    loadingRef: clickLoading,
    run: (waitAsync) => {
      if(unref(eventParams)['inParams']){
        return clickEvent('click', {btnObj:unref(props),...unref(eventParams)['inParams']}, undefined, waitAsync);
      }
      if(unref(props).userEvents&&unref(props).userEvents.length>0){
        return clickEvent('click', {btnObj:unref(props)},unref(props).userEvents, waitAsync);
      }
      return clickEvent('click', {btnObj:unref(props)}, undefined, waitAsync);
    },
  });
}
if(unref(vuex)['showCtl']===false){
  unref(props).showMenuItem=false;
}
</script>

<style type="text/css" lang="less">
.ant-btn.xmButton{
  &.bdBig{
    border-radius: 8px;
  }
  display: flex;
  align-items: center;
  justify-content: center;
}
div.xmButton,span.xmButton{
  .ant-btn{
    width:100%;
  }
}
</style>
